import { fromJS } from "immutable";

export const STATE_COMMUNICATION_CONFIG = "communicationConfig";
export const STATE_COMMUNICATION_CONFIG_DATA = "data";
export const STATE_COMMUNICATION_CONFIG_WEBCHAT_KEY = "webchatKey";
export const STATE_COMMUNICATION_CONFIG_ORIGIN = "origin";
export const STATE_COMMUNICATION_CONFIG_PATHNAME = "pathname";
export const STATE_COMMUNICATION_CONFIG_IS_DEBUGGER_MODE = "isDebuggerMode";

export const STATE_COMMUNICATION_CONFIG_DEFAULT = fromJS({
  [STATE_COMMUNICATION_CONFIG_DATA]: {
    [STATE_COMMUNICATION_CONFIG_WEBCHAT_KEY]: "",
    [STATE_COMMUNICATION_CONFIG_ORIGIN]: "",
    [STATE_COMMUNICATION_CONFIG_PATHNAME]: "",
    [STATE_COMMUNICATION_CONFIG_IS_DEBUGGER_MODE]: false,
  },
});
